const getRandomKey = () => btoa(Math.random()).substring(0, 12)

export default getRandomKey
